document.addEventListener("DOMContentLoaded", function () {
	console.log("👋 from Barking Dog Studios!");
});
